<div class="contents-area" (dragstart)="onDragstartBody($event)">
  <div class="split_two_part">
    <div>
      <div class="element-column">
        <div class="column-list">
          <label class="list-input-title">部門</label>
          <div class="list-input-content">
            <app-class-code-combo-box id="cmb_ClassCode" #cmb_ClassCode [subid]="'cmb_ClassCode'" [tabindex]="0"
              [(ngModel)]="kymw9009Model.classCode" [forcedEnabledMode]="'true'" [required]="false">
            </app-class-code-combo-box>
            <button id="btn_Display" class="btn-secondary" #btn_Display [tabindex]="0" forcedEnabledMode="true"
              (click)="eventDisplay_CLICKHandler()">表示</button>
          </div>
        </div>
        <wj-flex-grid #dtg_UserClassList [itemsSource]="kymw9009Model.userClassList" id="dtg_UserClassList"
          [headersVisibility]="'Column'" [isReadOnly]="true" [selectionMode]="'None'" [allowSorting]="false" [tabindex]="0"
          [alternatingRowStep]="0" [autoGenerateColumns]="false" forcedEnabledMode="true"
          (initialized)="onDtgUserClassListInitialized(dtg_UserClassList)" (pasting)="onPasting($event)">

          <wj-flex-grid-column [header]="'部門'" [minWidth]="5" [width]="100" [align]="'left'" [binding]="'ClassName'" id="dgc_ClassName" [cssClass]="'col-class-name'">
          </wj-flex-grid-column>

          <wj-flex-grid-column [header]="' '" [minWidth]="5" [width]="30" [align]="'center'" [binding]="'GroupUserCheck'" id="dgc_GroupCheck" [cssClass]="'col-check'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="checkbox" [tabindex]="0"
                *ngIf="cell.item.GroupUserEdit" 
                [(ngModel)]="cell.item.GroupUserCheck" 
                (change)="kymw9009Model.reflectSameLevel(cell.item, 'Group')"
                (mouseup)="$event.stopPropagation()" />
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [header]="'ユーザＩＤ'" [minWidth]="5" [width]="95" [align]="'left'" [binding]="'GroupUserId'" id="dgc_GroupUserId" [cssClass]="'col-user-id'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="text"  [style.width.%]="100" autocomplete="off" [restrict]="'[a-zA-Z0-9]'" [maxlength]="8" [tabindex]="0"
                [class]="cell.item.GroupUserError ? 'text-label-required text-label-error' : 'text-label-required'"
                [disabled] = "cell.item.Disabled"
                plessInputTextSub *ngIf="cell.item.GroupUserEdit" 
                [(ngModel)]="cell.item.GroupUserId"
                (blur)="eventUserId_FOCUSOUTHandler(cell.row.index, 'Group')">
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [header]="'氏名'" [minWidth]="5" [width]="138" [align]="'left'" [binding]="'GroupUserName'" id="dgc_GroupUserName" [cssClass]="'col-user-name'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <span *ngIf="cell.item.GroupUserEdit"
                [class]="cell.item.GroupUserError ? 'text-label-error' : ''">{{cell.item.GroupUserName}}</span>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [header]="' '" [minWidth]="5" [width]="70" [align]="'center'" [binding]="'GroupUserAdd'" id="dgc_GroupAdd" [cssClass]="'col-add'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <button #btn_Add class="btn-secondary btn_Add" [tabindex]="-1"
                [disabled] = "cell.item.Disabled"
                *ngIf="cell.item.GroupUserAdd"
                (click)="eventUserAdd_CLICKHandler(cell.row.index, 'Group')">追加</button>
            </ng-template>
          </wj-flex-grid-column>

          <wj-flex-grid-column [header]="' '" [minWidth]="5" [width]="30" [align]="'center'" [binding]="'StaffUserCheck'" id="dgc_StaffCheck" [cssClass]="'col-check'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="checkbox" [tabindex]="0"
                *ngIf="cell.item.StaffUserEdit" 
                [(ngModel)]="cell.item.StaffUserCheck" 
                (change)="kymw9009Model.reflectSameLevel(cell.item, 'Staff')"
                (mouseup)="$event.stopPropagation()" />
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [header]="'ユーザＩＤ'" [minWidth]="5" [width]="95" [align]="'left'" [binding]="'StaffUserId'" id="dgc_StaffUserId" [cssClass]="'col-user-id'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="text"  [style.width.%]="100" autocomplete="off" [restrict]="'[a-zA-Z0-9]'" [maxlength]="8" [tabindex]="0"
                [class]="cell.item.StaffUserError ? 'text-label-required text-label-error' : 'text-label-required'"
                [disabled] = "cell.item.Disabled"
                plessInputTextSub *ngIf="cell.item.StaffUserEdit" 
                [(ngModel)]="cell.item.StaffUserId"
                (blur)="eventUserId_FOCUSOUTHandler(cell.row.index, 'Staff')">
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [header]="'氏名'" [minWidth]="5" [width]="138" [align]="'left'" [binding]="'StaffUserName'" id="dgc_StaffUserName" [cssClass]="'col-user-name'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <span *ngIf="cell.item.StaffUserEdit"
              [class]="cell.item.StaffUserError ? 'text-label-error' : ''">{{cell.item.StaffUserName}}</span>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [header]="' '" [minWidth]="5" [width]="70" [align]="'center'" [binding]="'StaffUserAdd'" id="dgc_StaffAdd" [cssClass]="'col-add'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <button #btn_Add class="btn-secondary btn_Add" [tabindex]="-1"
                [disabled] = "cell.item.Disabled"
                *ngIf="cell.item.StaffUserAdd"
                (click)="eventUserAdd_CLICKHandler(cell.row.index, 'Staff')">追加</button>
            </ng-template>
          </wj-flex-grid-column>

          <wj-flex-grid-column [header]="' '" [minWidth]="5" [width]="30" [align]="'center'" [binding]="'AgentUserCheck'" id="dgc_AgentCheck" [cssClass]="'col-check'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="checkbox" [tabindex]="0"
                *ngIf="cell.item.AgentUserEdit" 
                [(ngModel)]="cell.item.AgentUserCheck" 
                (change)="kymw9009Model.reflectSameLevel(cell.item, 'Agent')"
                (mouseup)="$event.stopPropagation()" />
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [header]="'ユーザＩＤ'" [minWidth]="5" [width]="95" [align]="'left'" [binding]="'AgentUserId'" id="dgc_AgentUserId" [cssClass]="'col-user-id'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <input type="text"  [style.width.%]="100" autocomplete="off" [restrict]="'[a-zA-Z0-9]'" [maxlength]="8" [tabindex]="0"
                [class]="cell.item.AgentUserError ? 'text-label-required text-label-error' : 'text-label-required'"
                [disabled] = "cell.item.Disabled"
                plessInputTextSub *ngIf="cell.item.AgentUserEdit" 
                [(ngModel)]="cell.item.AgentUserId"
                (blur)="eventUserId_FOCUSOUTHandler(cell.row.index, 'Agent')">
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [header]="'氏名'" [minWidth]="5" [width]="138" [align]="'left'" [binding]="'AgentUserName'" id="dgc_AgentUserName" [cssClass]="'col-user-name'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <span *ngIf="cell.item.AgentUserEdit"
                [class]="cell.item.AgentUserError ? 'text-label-error' : ''">{{cell.item.AgentUserName}}</span>
            </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column [header]="' '" [minWidth]="5" [width]="73" [align]="'center'" [binding]="'AgentUserAdd'" id="dgc_AgentAdd" [cssClass]="'col-add col-add-agent'">
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
              <button #btn_Add class="btn-secondary btn_Add" [tabindex]="-1"
                [disabled] = "cell.item.Disabled"
                *ngIf="cell.item.AgentUserAdd"
                (click)="eventUserAdd_CLICKHandler(cell.row.index, 'Agent')">追加</button>
            </ng-template>
          </wj-flex-grid-column>
        </wj-flex-grid>

        <div class="layout_balance">
          <button id="btn_Delete" class="btn-tartiary warning"  #btn_Delete [tabindex]="0"
            (click)="eventDelete_CLICKHandler()">チェックしたユーザ階層を削除</button>
          <button id="btn_Update" class="btn-primary" #btn_Update [tabindex]="0"
            (click)="eventUpdate_CLICKHandler()">更新</button>
        </div>
      </div>
    </div>

    <div>
      <div class="element-column">
        <div class="column-list">
          <label class="list-input-title">氏名</label>
          <div class="list-input-content">
            <div class="element-row">
              <app-text-input id="txt_UserNmKanji" #txt_UserNmKanji [subid]="'txt_UserNmKanji'"
                [forcedEnabledMode]="'true'" [restrict]="'[ -￮]'" [maxChars]="20" [displayCountField]="false"
                [editable]="true" [tabindex]="0" class="txt-search">
              </app-text-input>
            </div>
          </div>
          <label class="list-input-title">所属</label>
          <div class="list-input-content">
            <div class="element-row">
              <app-text-input id="txt_UserDeptNm" #txt_UserDeptNm [subid]="'txt_UserDeptNm'"
                [forcedEnabledMode]="'true'" [restrict]="'[ -￮]'" [maxChars]="50" [displayCountField]="false"
                [editable]="true" [tabindex]="0" class="txt-search">
              </app-text-input>
              <button id="btn_Search" class="btn-secondary" #btn_Search [tabindex]="0" (click)="eventSearch_CLICKHandler()"
                forcedEnabledMode="true">検索</button>
              </div>
          </div>
        </div>
        <wj-flex-grid #dtg_OktInfoList [itemsSource]="kymw9009Model.oktaInfoList" id="dtg_OktInfoList"
          [headersVisibility]="'Column'" class="wj-flexgrid" [isReadOnly]="true"
          [selectionMode]="'Row'" [allowSorting]="false" [allowDragging]="'None'" [tabindex]="0"
          forcedEnabledMode="true">
          <wj-flex-grid-column [header]="'ユーザーＩＤ'" [minWidth]="5" [width]="90" [align]="'left'" [binding]="'UserId'"></wj-flex-grid-column>
          <wj-flex-grid-column [header]="'氏名'" [minWidth]="5" [width]="130" [align]="'left'" [binding]="'UserNmKanji'"></wj-flex-grid-column>
          <wj-flex-grid-column [header]="'所属'" [minWidth]="5" [width]="190" [align]="'left'" [binding]="'UserDeptNm'"></wj-flex-grid-column>
          <wj-flex-grid-column [header]="'権限'" [minWidth]="5" [width]="50"  [align]="'left'" [binding]="'CrossId'"></wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </div>
  </div>
</div>